// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"721":"9300877f","917":"e3590aee"}[chunkId] + ".chunk.css";
};